//审批流节点数据封装
const dealStepData = (data) => {
  let initiateApproval = require("@/assets/img/approval/fqsp.png");//发起审批
  let pendingApproval = require("@/assets/img/approval/dsp.png");//待审批
  let approved = require("@/assets/img/approval/sptg.png");//审批通过
  let inApproval = require("@/assets/img/approval/spz.png");//审批中
  let approvalReject = require("@/assets/img/approval/spjj.png");//审批拒绝

  let approvalData = [];
  let handleData = data;

  handleData.forEach((item, index) => {

    //剔除掉第一个数据 和 询比价详情封装的最后一个数据
    if (Number(item.auditStatus) === 1 && index !== 0) {
      item.icon = approved;
      if (item.tip) {//处理最后一个节点的数据
        item.step = '审核通过';
      } else {
        item.step = '审批通过';
      }
    } else if (Number(item.auditStatus) === 2) {
      item.icon = approvalReject;
      if (item.tip) {
        item.step = '审核拒绝';
      } else {
        item.step = '审批拒绝';
      }
    } else if (Number(item.auditStatus) === 3) {
      item.icon = inApproval;
      if (item.tip) {
        item.step = '审核中';
      } else {
        item.step = '审批中';
      }
    } else if (Number(item.auditStatus) === 0) {
      item.icon = pendingApproval;
      if (item.tip) {
        item.step = '待审核';
      } else {
        item.step = '待审批';
      }
    }


    if (item.nodeMember) {
      if (!item.nodeMember.auditMemberPhone) {
        item.nodeMember.auditMemberPhone = '';
      }
      if (!item.nodeMember.approveTime && item.nodeMember.updateTime) {
        item.nodeMember.approveTime = item.nodeMember.updateTime;
      }
    }
  })


  for (let i = 0; i < handleData.length; i += 5) {
    approvalData.push(data.slice(i, i + 5));
  }
  for (let i = 0; i < approvalData.length; i++) {
    if (i % 2 === 1) {
      approvalData[i] = approvalData[i].reverse();
    }
  }
  return approvalData;
}


export default {
  dealStepData
}
